import dayjs from "dayjs";
import weekOfYear from "dayjs/plugin/weekOfYear";

dayjs.extend(weekOfYear);

export const buildStatisticsData = (data) => {
  const results = {};

  if (!data) {
    return null;
  }

  for (const item of data) {
    const week = dayjs(item.created_at).week(); // Adjust to get week/year
    const year = new Date(item.created_at).getFullYear();
    const key = `${year}-${week}`;

    if (!results[key]) {
      results[key] = {
        total_visits: 0,
        unique_visitors: new Set(), // Use Set to track unique visitors
        actions: [],
        traffic_source: {}
      };
    }

    // Aggregate visit counts
    results[key].total_visits += item.visit_count || 0;

    // Track unique visitors
    if (item.uuid) {
      results[key].unique_visitors.add(item.uuid);
    }

    // Track unique traffic source
    if (item.traffic_source) {
      const currentSource = results[key].traffic_source
      const currentSourceDomain = item.traffic_source?.domain
      let finaCount = 0;
      if (currentSourceDomain in (currentSource || {})){
        finaCount = currentSource[currentSourceDomain];
      } 
      currentSource[currentSourceDomain] = finaCount + 1;
      results[key].traffic_source = currentSource;
    }

    // Aggregate actions
    const actions = item?.actions || [];
    for (const action of actions) {
      const actionKey = `${action.name} (${action?.event} ${action?.type})`;
      if (!results[key].actions[actionKey]) {
        results[key].actions[actionKey] = 0;
      }
      results[key].actions[actionKey] += 1; // Count actions
    };
  };

  // Step 3: Prepare final output
  const finalResults = Object.entries(results).map(([key, value]) => ({
    week: key.split('-')[1],
    year: key.split('-')[0],
    total_visits: value.total_visits,
    unique_visitors: value.unique_visitors.size,
    traffic_source: value?.traffic_source,
    actions: value?.actions
  }));

  // Calculate growth as a unique field
  finalResults.forEach((result, index) => {
    result.growth = index > 0 ? result.unique_visitors - finalResults[index - 1].unique_visitors : 0;
  });

  // Create a unique object for final output
  const output = {
    unique_visitors: finalResults.reduce((acc, res) => acc + res.unique_visitors, 0),
    total_visits: finalResults.reduce((acc, res) => acc + res.total_visits, 0),
    growth: finalResults.reduce((acc, res) => acc + res.growth, 0),
    data: finalResults
  };

  return output;
}